import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PARAMETER} from '../../constants';

export default {
  id: 'INFO_RAPP_HEBDO',
  title: 'Qu’est-ce que les rapports hebdomadaires ?',
  description: '',
  categories: [CONTENT_CATEGORY_PARAMETER],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Si vous activez les Rapports Hebdomadaires vous allez recevoir chaque semaine par mail la liste de vos fournisseurs avec l’état de leur Quitus. Vous pouvez également les activer pour vos fournisseurs liés aux opérations.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Pour modifier vos rapports hebdomadaires, cliquez sur le bonhomme en bas à gauche'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_INFO_RAPP_HEBDO/FR_INFO_RAPP_HEBDO_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Rendez-vous sur « Informations personnelles »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_INFO_RAPP_HEBDO/FR_INFO_RAPP_HEBDO_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Activez ou désactivez vos rapports, puis validez !'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_INFO_RAPP_HEBDO/FR_INFO_RAPP_HEBDO_3.png`
  }]
};
